// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles-module--wrap--OotWO","separator":"styles-module--separator--fkyXe","link":"styles-module--link--1roXX","active":"styles-module--active--2BcQJ"};